/**
 * Created by Christof Sander on 16.01.2017.
 */

var uuid = require('uuid');
var uploadRoute = '/upload/preparedImage';
var plupload = require('plupload');

module.exports = {
	config: {
		mode: 		'image',
		secureRoute: uploadRoute,
		showTaggedUpload: false,
		pluploaderConfig: {
			runtimes:               'html5,flash,silverlight,html4',
			// browse_button:          'upload', // will be set by attach-trigger
			container:              undefined, // ... or DOM Element itself
			url:                    uploadRoute,
			chunk_size:             '200kb',
			// unique_names:           true,     //-> we want the original filename -> don't use it
			max_retries:            3,
			flash_swf_url:          '/webpack/js/Moxie.swf',
			silverlight_xap_url:    '/webpack/js/Moxie.xap',

			headers: {},

			multipart_params: {
				fileID: 'replaceThis',
				categories: {}
			},

			filters: {
				// prevent_duplicates : true,
				max_file_size : '50mb',
				mime_types: [
					{title : "Image files", extensions : "jpg,jpeg,gif,png,svg"}
				]
			},

			init: {
				PostInit: function(up){
					// console.log('PostInit', arguments);
					// document.getElementById('filelist').innerHTML = '';
					//
					// document.getElementById('uploadfiles').onclick = function() {
					// 	uploader.start();
					// 	return false;
					// };
				},

				FilesAdded: function(up, files) {
					// console.log('FilesAdded', arguments);

					var $progress = up.component.$.find('.progress');
					$progress.addClass('inProgress');

					up.component.model.uploadedMediaIDs = [];
					up.settings.multipart_params.categories = JSON.stringify(up.component.model.mediaCategories || {});

					up.start();
					// plupload.each(files, function(file) {
					// 	document.getElementById('filelist').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ') <b></b></div>';
					// });
				},

				BeforeUpload: function(up, file){
					// set file id for the actual file
					up.settings.multipart_params.fileID = uuid.v4();
					// console.log('BeforeUpload', arguments);
				},

				UploadProgress: function(up, file) {
					// console.log('UploadProgress', arguments);

					var $progress = up.component.$.find('.progress');
					var $progressBar = $progress.find('.background');
					var $progressContent = $progress.find('.content');
					$progressBar.width(up.total.percent + '%');
					$progressContent.html(up.total.percent + '%');
					// document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
				},

				FileUploaded: function(up, file, result){
					// console.log('FileUploaded', arguments);

					if(result.status === 200 && result.response){
						result.response = JSON.parse(result.response);
						up.component.model.lastResponse = result.response;

						if(result.response.mediaID){
							up.component.model.uploadedMediaIDs.push(result.response.mediaID)
						}

						if(up.component.config.mode === 'file'){
							up.component.closest('templates_mediaManagement_file_file', function(mediaManagementComponent){
								mediaManagementComponent.find('templates_mediaManagement_file_fileList', function(fileListComponent){
									fileListComponent.addNewFile((result.response || {}).data, true);
								});
							})
						}
						else {
							up.component.closest('templates_mediaManagement_image_image', function(mediaManagementComponent){
								mediaManagementComponent.find('templates_mediaManagement_image_imageList', function(imageListComponent){
									imageListComponent.addNewImage((result.response || {}).data, true);
								});
							});
						}
					}
				},

				UploadComplete: function(up, files){
					// console.log('UploadComplete', arguments);

					var $progress = up.component.$.find('.progress');
					var $progressBar = $progress.find('.background');
					$progress.removeClass('inProgress');
					$progressBar.width('0');

					if(typeof(up.component.uploadComplete) === 'function'){
						up.component.uploadComplete(files)
					}

					delete up.component.model.mediaCategories;
					delete up.component.model.uploadedMediaIDs;
					delete up.settings.multipart_params.categories;
				},

				Error: function(up, error) {
					var errorCode;
					switch(error.code){
						case plupload.HTTP_ERROR:                    errorCode = 'http'; break;
						case plupload.IO_ERROR:                      errorCode = 'io'; break;
						case plupload.SECURITY_ERROR:                errorCode = 'security'; break;
						case plupload.INIT_ERROR:                    errorCode = 'init'; break;
						case plupload.FILE_SIZE_ERROR:               errorCode = 'file-size'; break;
						case plupload.FILE_EXTENSION_ERROR:          errorCode = 'file-extension'; break;
						case plupload.FILE_DUPLICATE_ERROR:          errorCode = 'file-duplicate'; break;
						case plupload.IMAGE_FORMAT_ERROR:            errorCode = 'image-format'; break;
						case plupload.MEMORY_ERROR:                  errorCode = 'memory'; break;
						case plupload.IMAGE_DIMENSIONS_ERROR:        errorCode = 'image-dimensions'; break;
						case plupload.GENERIC_ERROR:
						default:                            errorCode = 'generic'; break;
					}

					up.component.performAction(up.component.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:pluploader.' + errorCode
						}
					}));
				}
			}
		}
	},
	model: {
		errors: [],
		mediaCategories: [],
		uploadedMediaIDs: []
	},

	events: {
		taggedUpload: {
			type: 'click',
			selector: '.taggedUpload',
			action: function(event){
				var self = event.data.component;
				self.model.mediaCategories = [];
				self.closest('base_modal_modal', function(modal){
					modal.find('base_form_fields_tag-picker-button', function(tagPickerButton){
						tagPickerButton.open(undefined, function(options){
							var categories = ((options || {}).decisionOptions || {}).dirtyAssignedTags || {};
							self.model.mediaCategories = []
							for(var i in categories){
								self.model.mediaCategories.push({
									categoryID: 	categories[i].categoryID,
									categoryDataID: categories[i].categoryDataID,
									enabled: 		categories[i].enabled,
								});
							}
							self.$.find('.untaggedUpload').click();
						});
					});
				});
			}
		}
	},

	methods: {
		uploadComplete: function(){
			if((this.model.uploadedMediaIDs || []).length > 0){
				this.triggerClosest('updateMediaTagsInList', { mediaIDs: this.model.uploadedMediaIDs });
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				this.model.fileConfig = this.getResourceRegisterContent('fileConfig') || {};
				this.model.managementConfig = this.model.fileConfig.managementConfig || {};
				this.model.uploaderConfig = this.model.managementConfig.uploaderConfig || {};
			}

			this.config.pluploaderConfig.headers['fec_secure_route'] = this.config.secureRoute;
			this.config.pluploaderConfig.container = $element.find('.uploads')[0];
			this.config.pluploaderConfig.browse_button = 'upload_' + this.config.mode;

			var atomConfigFilters;
			if((atomConfigFilters = this.model.uploaderConfig.filters)){
				if(atomConfigFilters.mime_types) this.config.pluploaderConfig.filters.mime_types = atomConfigFilters.mime_types;
				if(atomConfigFilters.max_file_size) this.config.pluploaderConfig.filters.max_file_size = atomConfigFilters.max_file_size;
			}

			this.model._uploader = new plupload.Uploader(this.config.pluploaderConfig);
			this.model._uploader.init();
			this.model._uploader.component = this;
		}
	}
};